import * as React from 'react';

import { Container } from '../../../../components/Container';
import { Text } from '../../../../components/Text';
import { Divider } from '../../../../components/Divider';
import { SIZE_8, SIZE_24, SIZE_28 } from '../../../../constants/sizes';

export const renderTitle = (title: string): React.ReactNode => (
  <Container padding={`0 ${SIZE_28} 0`}>
    <Container padding={`${SIZE_24} 0 ${SIZE_8}`}>
      <Text fontSize={18} lineHeight={24} fontWeight="bold">
        {title}
      </Text>
    </Container>
    <Divider />
  </Container>
);
